import React from 'react';
import useCountDownCounter from './hooks/useCountDownCounter';
interface CountDownProps {
  label?: string;
  description?: string;
  dateTime: string;
  isMonth?: boolean;
}
const CountDown = ({dateTime, description, label, isMonth}: CountDownProps) => {
  const {days, hours, minutes, months} = useCountDownCounter({
    dateTime: dateTime,
  });
  return (
    <div className="flex flex-col w-full">
      {label && <h4 className="text-sm font-Medium text-gray-950">{label}</h4>}
      {description && (
        <p className="text-sm font-Regular text-gray-900">{description}</p>
      )}
      <div className="flex w-full justify-center">
        <div className="flex w-[50%] justify-center gap-3 items-center">
          <div className="flex flex-col items-center">
            <span className="text-[32px] text-gray-900 font-Regular">
              {minutes}
            </span>
            <span className="text-xs font-Regular text-gray-700">دقیقه</span>
          </div>
          <div className="border-[1px]  border-l-gray-200 flex w-[1px] h-[60%]" />
          <div className="flex flex-col items-center">
            <span className="text-[32px] text-gray-900 font-Regular">
              {hours}
            </span>
            <span className="text-xs font-Regular text-gray-700">ساعت</span>
          </div>
          <div className="border-[1px]  border-l-gray-200 flex w-[1px] h-[60%]" />
          <div className="flex flex-col items-center">
            <span className="text-[32px] text-gray-900 font-Regular">
              {days}
            </span>
            <span className="text-xs font-Regular text-gray-700">روز</span>
          </div>
          {isMonth && (
            <>
              <div className="border-[1px]  border-l-gray-200 flex w-[1px] h-[60%]" />
              <div className="flex flex-col items-center">
                <span className="text-[32px] text-gray-900 font-Regular">
                  {months}
                </span>
                <span className="text-xs font-Regular text-gray-700">ماه</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountDown;
